import { render, staticRenderFns } from "./HowToOrder.vue?vue&type=template&id=ced57234&"
import script from "./HowToOrder.vue?vue&type=script&lang=js&"
export * from "./HowToOrder.vue?vue&type=script&lang=js&"
import style0 from "./HowToOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports